import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router, CanActivate} from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from '../../services/user.service';
import { AlertService } from '../../services/alert.service';
import { NeoComunService } from 'src/app/comun/services/neoComun.service';
import { map } from 'rxjs/operators';
import { SweetAlertService } from 'src/app/services/sweet-alert.service';

@Injectable({
  providedIn: 'root',
})
export class UserGuard implements CanActivate{
  constructor(
    private _user: UserService,
    private _alert: AlertService,
    private router: Router,
    private _comun: NeoComunService,
    private _sweetAlert:SweetAlertService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (this._user.getUser()) {
      if (this._user.getUser().actor === 'intermediario') {
        if (route.routeConfig.path === 'home') {
          return true;
        } else {
          var ruta = route.routeConfig.path.replace('/:id', '').replace('/:idCiudad', '').replace('/:idDepartamento', '');
          switch (ruta) {
            case 'transaccional/revisarSolicitudes/propuestaIntermediario':
              ruta = 'transaccional/revisarSolicitudes';
              break;
            case 'consultar/detallePropuestaIF/verDetallePropuesta':
              ruta = 'transaccional/aprobarSolicitudes';
              break;
            case 'transaccional/aprobarSolicitudes/aprobarOferta':
              ruta = 'transaccional/aprobarSolicitudes';
              break;
            case 'transaccional/aprobarSolicitudes/negarOferta':
              ruta = 'transaccional/aprobarSolicitudes';
              break;
            case 'transaccional/aprobarSolicitudes/devolverOferta':
              ruta = 'transaccional/aprobarSolicitudes';
              break;
            case 'transaccional/aprobarSolicitudes/confirmarNegacion':
              ruta = 'transaccional/aprobarSolicitudes';
              break;
            case 'transaccional/aprobarSolicitudes/devolverNegacion':
              ruta = 'transaccional/aprobarSolicitudes';
              break;
            case 'administracion/administracionFechayHora/crear':
              ruta = 'administracion/administracionFechayHora';
              break;
            case 'administracion/lineascredito/crear':
              ruta = 'administracion/lineascredito';
            case 'administracion/lineascredito/crearLinea':
              ruta = 'administracion/lineascredito';
              break;
            case 'administracion/ubicaciones/crear':
              ruta = 'administracion/ubicaciones';
              break;
            case 'administracion/ubicaciones/editarDepartamento':
              ruta = 'administracion/ubicaciones';
              break;
            default:
              break;
          }
          return this._comun.isAccessByRol(`/intermediario/${ruta}`).pipe(
            map((response: any) => {
              if (response.exitoso) {
                return true;
              } else {
                this._sweetAlert.errorModal("Error!",true,
                  'Su usuario no cuenta con los permisos para esta funcionalidad'
                );
                this.router.navigateByUrl('/intermediario/home');
                return false;
              }
            })
          );
        }
      } else {
        this._sweetAlert.errorModal("Error!",true,'No se encuentra logueado en el sistema');
        this.router.navigateByUrl('/intermediario/login');
        return false;
      }
    }
  }
}
